// Portfolio Administration v1.0 PR 4b — collapsible section card used
// by the 10 Defaults & Workout case-workspace sections. Mirrors
// shadcn/Radix Accordion behavior without dragging in a new
// dependency. Two-state details/summary semantics keep keyboard
// navigation accessible by default.

import type { ReactNode } from "react";
import { ChevronDown } from "lucide-react";

interface AccordionCardProps {
  title: string;
  badge?: ReactNode;
  defaultOpen?: boolean;
  testId?: string;
  children: ReactNode;
  actions?: ReactNode;
}

export function AccordionCard({
  title,
  badge,
  defaultOpen = false,
  testId,
  children,
  actions,
}: AccordionCardProps) {
  return (
    <details
      className="group bg-white-pure border border-border-light rounded-md"
      open={defaultOpen}
      data-testid={testId}
    >
      <summary
        className="cursor-pointer list-none flex items-center justify-between gap-space-3 px-space-3 py-space-2 hover:bg-white-warm rounded-t-md"
      >
        <div className="flex items-center gap-space-2 min-w-0">
          <ChevronDown
            size={14}
            aria-hidden
            className="transition-transform group-open:rotate-180"
          />
          <h3 className="font-display font-bold text-h4 m-0">{title}</h3>
          {badge}
        </div>
        {actions && (
          <div onClick={(e) => e.stopPropagation()} onKeyDown={(e) => e.stopPropagation()}>
            {actions}
          </div>
        )}
      </summary>
      <div className="p-space-3 border-t border-border-light">{children}</div>
    </details>
  );
}
